export const COMPARISON_COLORS = [
    "#2196F3",
    "#FF9800",
    "#4CAF50",
    "#E91E63",
    "#9C27B0",
    "#00BCD4",
    "#FF5722",
    "#607D8B",
];
